import React from "react";
import './navbar.css';
import {
  Navbar,
  Typography,
  Button,
  IconButton,
  Collapse
} from "@material-tailwind/react";
import { useLocation } from "react-router-dom"; 
import NavListMenu from "./NavListMenu"; 
import { useNavigate } from "react-router-dom";
import '../styles/lines.css'
export function StickyNavbar() {
  const [openNav, setOpenNav] = React.useState(false);
  const [isScrolled, setIsScrolled] = React.useState(false);
  const [isDarkBackground, setIsDarkBackground] = React.useState(false);

  const location = useLocation();
  const isHomePage = location.pathname === '/' || location.pathname === '/home';
  const isTechPage =  location.pathname === '/tech';
  React.useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector(".navbar");
      if (navbar) {
        const bgColor = window.getComputedStyle(navbar).backgroundColor;
        const rgb = bgColor.match(/\d+/g);
        if (rgb) {
          const brightness = (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]);
          setIsDarkBackground(brightness < 128);
        }
      }
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navList = (
    <ul
    className={` font-poppins mt-2 mb-4 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6 ${
      isScrolled ? "text-black" : isDarkBackground || isHomePage || isTechPage ? "text-white" : "text-black"
    }`}
  >
    {[
      { name: "Work", path: "/work" },
      { name: "About Us", path: "/about-us" },
      { name: "Tech", path: "/tech" }, // Update if needed
    ].map((item) => (
      <Typography
        key={item.name}
        as="li"
        variant="small"
        className="p-1 font-poppins font-sans hover:font-poppins hover:text-[#96226E] cursor-pointer"
        onClick={() => navigate(item.path)}
      >
        <span className="font-poppins flex items-center">
          {item.name}
        </span>
      </Typography>
    ))}

    <NavListMenu />
  </ul>
  );
  const navigate = useNavigate();
  const handleLogoClick = () => {
    navigate("/");
  };
  return (
    <Navbar
      className={`sticky fixed top-0 z-20 w-full max-w-screen-1xl rounded-none ${isScrolled ? "bg-white shadow-md" : "bg-transparent shadow-none backdrop-blur-[3px]"
        } border-0 backdrop-blur-[3px]`}
    >
      <div className="flex items-center justify-between text-blue-gray-900">
        <div className="flex items-center ml-0">
          <img src="logo.png" onClick={handleLogoClick} alt="codify" className="h-16 w-auto mr-8 cursor-pointer" />
          <Typography
            as="a"
            href="#"
            className="mr-4 cursor-pointer py-1.5 font-medium"
          ></Typography>
        </div>
        <div className="hidden lg:flex items-center gap-6">{navList}</div>
        <Button
          size="lg"
          className="hidden lg:inline-block font-poppins bg-[#96226E] hover:font-poppins hover:bg-[#B53A85] rounded-full relative -left-[2.1rem] w-[180px] flex justify-center items-center font-bold"
          onClick={() => navigate("/start-a-project")}
        >
          <span>BOOK A CALL</span>
        </Button>
        <IconButton
          variant="text"
          className="ml-auto h-6 w-6 text-inherit hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden"
          ripple={false}
          onClick={() => setOpenNav(!openNav)}
        >
          {openNav ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              className="h-6 w-6"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          )}
        </IconButton>
      </div>
      <Collapse open={openNav}>{navList}</Collapse>
    </Navbar>
  );
}
